import { sphereLabel, type SphereId } from '@superposition/domain';
import { useLoadedState } from './store.js';
import { useLocale } from './profile.js';

/** название сферы так, как его назвал человек; без переименования — стандартное */
export function useSphereName(): (id: SphereId) => string {
  const { state } = useLoadedState();
  const locale = useLocale();
  return (id) => sphereLabel(id, state.sphereNames, locale);
}
